import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/brand/Logo";

const COL_1 = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/future-builders-lab", label: "Future Builders Lab" },
];

const COL_2 = [
    { to: "/sponsor", label: "Sponsor a Student" },
    { to: "/student-interest", label: "Student Interest" },
    { to: "/parent-info", label: "Parent Information" },
    { to: "/partner", label: "Partner With Us" },
];

const COL_3 = [
    { to: "/contact", label: "Contact" },
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/terms", label: "Terms / Participation Disclaimer" },
];

const FooterColumn = ({ heading, links, testId }) => (
    <div data-testid={testId}>
        <h3
            className="text-xs font-semibold uppercase tracking-wider mb-4"
            style={{ color: "var(--text-secondary)" }}
        >
            {heading}
        </h3>
        <ul className="space-y-3">
            {links.map((l) => (
                <li key={l.to}>
                    <Link
                        to={l.to}
                        className="text-sm text-[var(--text-primary)] hover:text-white transition-colors"
                        data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}
                    >
                        {l.label}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative mt-12 border-t"
            style={{
                borderColor: "rgba(255,255,255,0.08)",
                background:
                    "linear-gradient(180deg, transparent 0%, rgba(15, 7, 32, 0.55) 30%)",
            }}
        >
            <div className="vfs-container py-14 lg:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
                    {/* Brand block */}
                    <div className="lg:col-span-1">
                        <Logo size={36} />
                        <p
                            className="mt-4 text-sm max-w-xs"
                            style={{ color: "var(--text-secondary)" }}
                        >
                            AI-era workforce readiness for Lee County students.
                        </p>
                    </div>

                    <FooterColumn
                        heading="Explore"
                        links={COL_1}
                        testId="footer-col-explore"
                    />
                    <FooterColumn
                        heading="Get Involved"
                        links={COL_2}
                        testId="footer-col-getinvolved"
                    />
                    <FooterColumn
                        heading="Info"
                        links={COL_3}
                        testId="footer-col-info"
                    />
                </div>

                <hr className="vfs-divider my-10" />

                <div className="space-y-3">
                    <p
                        className="text-xs"
                        style={{ color: "var(--text-secondary)" }}
                        data-testid="footer-copyright"
                    >
                        © 2026 Vibe for Success, Inc. A Florida nonprofit
                        corporation.
                    </p>
                    <p
                        className="text-xs leading-relaxed max-w-3xl"
                        style={{ color: "var(--text-muted)" }}
                        data-testid="footer-disclaimer"
                    >
                        Sponsorships and program support help fund pilot
                        development. Tax-deductible donation status should not
                        be assumed unless confirmed in writing by Vibe for
                        Success, Inc.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
